/**
 * collection-landing.js
 * Street Solutions UK
 *
 * Fetches all products from every subcollection added as a metafield,
 * deduplicates them, builds product cards, handles sorting,
 * pagination, and metafield-driven sidebar filters — all client-side.
 *
 * No product tagging required.
 */

(function () {
  'use strict';

  /* ── Config ── */
  const STOREFRONT_API_VERSION = '2025-01';
  const STOREFRONT_TOKEN       = window.clStorefrontToken || '';

  const PER_PAGE_DEFAULT       = 12;

  /* ── State ── */
  let allProducts     = [];   // deduped master list
  let filteredProducts = [];  // after filters applied
  let currentPage     = 1;
  let perPage         = PER_PAGE_DEFAULT;
  let sortKey         = 'relevance';
  let activeFilters   = {};   // { filterKey: Set(values) }

  /* ── DOM refs (resolved after DOMContentLoaded) ── */
  let grid, loadingEl, countEl, paginationEl, filterPanel;
  let perPageSelect, sortSelect;

  /* ─────────────────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('[data-collection-handle]');
    if (!wrapper) return;

    const subcols = wrapper.querySelector('[data-subcol-handles]');
    if (!subcols) return; // not a landing page

    grid         = document.getElementById('cl-product-grid');
    loadingEl    = document.getElementById('cl-loading-state');
    countEl      = document.getElementById('cl-product-count');
    paginationEl = document.getElementById('cl-pagination');
    filterPanel  = document.getElementById('cl-filter-panels');
    perPageSelect = document.querySelector('[data-cl-per-page]');
 //   sortSelect    = document.querySelector('[data-cl-sort]');
sortSelect = document.querySelector('[data-cl-sort]');

if (sortSelect) sortSelect.addEventListener('change', () => {
  sortKey = sortSelect.value;
  currentPage = 1;
  sortAndRender();
});
    const handles = subcols.dataset.subcolHandles
      .split(',')
      .map(h => h.trim())
      .filter(Boolean);

    if (!handles.length) {
      showEmpty();
      return;
    }

    // Apply CSS vars from section settings passed via data attrs on wrapper
    applyCssVars(wrapper);

    // View toggle
    document.querySelectorAll('.cl-view-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.cl-view-btn').forEach(b => {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });

    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');

    // Remove old classes
    grid.classList.remove('grid-cols-1','grid-cols-2','sm:grid-cols-3','xl:grid-cols-4','xl:grid-cols-5');

    // 👇 SET DATA ATTRIBUTE
    grid.setAttribute('data-layout', btn.dataset.view);

    if (btn.dataset.view === 'list') {
      grid.classList.add('grid-cols-1');
    } else if (btn.dataset.view === 'grid2') {
      grid.classList.add('grid-cols-2','sm:grid-cols-3');
    } else {
      grid.classList.add('grid-cols-2','sm:grid-cols-3','xl:grid-cols-4');
    }
  });
});

    // Controls
    if (perPageSelect) perPageSelect.addEventListener('change', () => {
      perPage = parseInt(perPageSelect.value, 10);
      currentPage = 1;
      render();
    });

    if (sortSelect) sortSelect.addEventListener('change', () => {
      sortKey = sortSelect.value;
      currentPage = 1;
      sortAndRender();
    });

    // Fetch
    fetchAllSubcollections(handles);
  });

  /* ─────────────────────────────────────────────────────────────
     CSS VAR INJECTION (section settings → CSS)
  ───────────────────────────────────────────────────────────── */
  function applyCssVars(wrapper) {
    const heroHeight   = wrapper.dataset.heroHeight;
    const overlayOpacity = wrapper.dataset.heroOverlay;
    const cardsPerRow  = wrapper.dataset.cardsPerRow;
    const root = document.querySelector('.cl-wrapper');
    if (!root) return;
    if (heroHeight)    root.style.setProperty('--cl-hero-height',   heroHeight + 'px');
    if (overlayOpacity) root.style.setProperty('--cl-hero-overlay', (overlayOpacity / 100).toFixed(2));
    if (cardsPerRow)   root.style.setProperty('--cl-cards-per-row', cardsPerRow);
  }

  /* ─────────────────────────────────────────────────────────────
     STOREFRONT API FETCH
  ───────────────────────────────────────────────────────────── */
  async function fetchAllSubcollections(handles) {
  showLoading(true);

  const allFetched = [];

  for (const handle of handles) {
    try {
      const products = await fetchCollectionProducts(handle);
      allFetched.push(...products);
    } catch (e) {
      console.warn('[CL] Failed:', handle, e);
    }
  }

  // ✅ ALWAYS HIDE LOADER
  showLoading(false);

  if (!allFetched.length) {
    showEmpty();
    return;
  }

  const seen = new Set();
  allProducts = allFetched.filter(p => {
    if (seen.has(p.id)) return false;
    seen.add(p.id);
    return true;
  });

  filteredProducts = [...allProducts];
  buildFilters();
  sortAndRender();
}
function getMetafieldIdentifiers() {
  const el = document.getElementById('cl-filter-groups');
  if (!el) return [];

  try {
    const groups = JSON.parse(el.textContent);

    return groups
      .map(g => g.key)
      .filter(k => k && k !== 'vendor' && k !== 'productType')
      .map(k => `{ namespace: "custom", key: "${k}" }`);
  } catch (e) {
    console.warn('Invalid filter groups JSON');
    return [];
  }
}

  async function fetchCollectionProducts(handle, cursor = null, accumulated = []) {

    const metafieldIdentifiers = getMetafieldIdentifiers();
let metafieldQuery = '';

if (metafieldIdentifiers.length > 0) {
  metafieldQuery = `
    metafields(identifiers: [
      ${metafieldIdentifiers.join(',')}
    ]) {
      key
      value
    }
  `;
}
   
    const afterClause = cursor ? `, after: "${cursor}"` : '';
    const query = `{
      collection(handle: "${handle}") {
        products(first: 250${afterClause}) {
          pageInfo { hasNextPage endCursor }
          edges {
           node {
              id
              title
              handle
              vendor
              productType

              availableForSale

              options {
                name
                values
              }

              priceRange {
                minVariantPrice { amount currencyCode }
              }

              compareAtPriceRange {
                minVariantPrice { amount currencyCode }
              }

              featuredImage {
                url(transform: { maxWidth: 600 })
                altText
              }

              images(first: 2) {
                edges {
                  node {
                    url
                    altText
                  }
                }
              }
              variants(first: 10) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                  }
                }
              }
                ${metafieldQuery}  
            }
          }
        }
      }
    }`;


    const resp = await storefrontFetch(query);
console.log(resp);
if (resp.errors) {
  console.error('GraphQL ERROR:', resp.errors);
  return accumulated; // prevent crash
}
const col  = resp?.data?.collection;
if (!col) return accumulated;

    const products = col.products.edges.map(e => e.node);
    accumulated.push(...products);

    if (col.products.pageInfo.hasNextPage) {
      return fetchCollectionProducts(handle, col.products.pageInfo.endCursor, accumulated);
    }
    return accumulated;
  }

  async function storefrontFetch(query) {
    const res = await fetch('/api/' + STOREFRONT_API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query }),
    });
    if (!res.ok) throw new Error('Storefront API error: ' + res.status);
    return res.json();
  }

  /* ─────────────────────────────────────────────────────────────
     SORT
  ───────────────────────────────────────────────────────────── */
  function sortProducts(products, key) {
    const p = [...products];
    switch (key) {
      case 'price-asc':
        return p.sort((a, b) => price(a) - price(b));
      case 'price-desc':
        return p.sort((a, b) => price(b) - price(a));
      case 'title-asc':
        return p.sort((a, b) => a.title.localeCompare(b.title));
      case 'title-desc':
        return p.sort((a, b) => b.title.localeCompare(a.title));
      case 'created-desc':
        // Storefront doesn't return createdAt in our query, keep API order
      default:
        return p;
    }
  }

  function price(p) {
    return parseFloat(p?.priceRange?.minVariantPrice?.amount || 0);
  }

  /* ─────────────────────────────────────────────────────────────
     FILTERS  (built from metafield custom.filter_groups)
  ───────────────────────────────────────────────────────────── */
  function buildFilters() {
    if (!filterPanel) return;

    // Pull filter_groups config injected via Liquid into a data attr
    const filterGroupsRaw = document.getElementById('cl-filter-groups');
    if (!filterGroupsRaw) return;

    let groups;
    try {
      groups = JSON.parse(filterGroupsRaw.textContent);
    } catch (e) {
      return;
    }
    

    if (!groups || !groups.length) return;

    filterPanel.innerHTML = '';

    groups.forEach(group => {
      // Gather unique values from products
      const values = [...new Set(
        allProducts
          .map(p => getProductMeta(p, group.key))
          .flat()
          .filter(Boolean)
      )].sort();

      if (!values.length) return;

      const groupEl = document.createElement('div');
      groupEl.className = 'cl-filter-group';
      groupEl.innerHTML = `
        <div class="cl-filter-group__title" role="button" tabindex="0"
             aria-expanded="true" aria-controls="fg-${group.key}">
          ${escHtml(group.label)}
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5"
               aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>
        </div>
        <div class="cl-filter-group__options" id="fg-${group.key}">
          ${values.map(v => `
            <label class="cl-filter-option">
              <input type="checkbox" data-filter-key="${escHtml(group.key)}"
                     data-filter-value="${escHtml(v)}">
              <span>${escHtml(v)}</span>
              <span class="cl-filter-option__count"></span>
            </label>
          `).join('')}
        </div>`;

      // Collapse toggle
      groupEl.querySelector('.cl-filter-group__title').addEventListener('click', () => {
        groupEl.classList.toggle('is-collapsed');
      });

      // Checkbox change
      groupEl.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        cb.addEventListener('change', onFilterChange);
      });

      filterPanel.appendChild(groupEl);
    });

    // Clear button
    const clearBtn = document.createElement('button');
    clearBtn.className = 'btn btn--primary w-full cl-filter-clear';
    clearBtn.textContent = 'Clear all filters';
    clearBtn.addEventListener('click', clearFilters);
    filterPanel.appendChild(clearBtn);

    updateFilterCounts();
  }
/*
  function getProductMeta(product, key) {
    // Products fetched via Storefront don't carry metafields without explicit query.
    // For vendor/type (common filter candidates) we can use built-in fields:
    if (key === 'vendor') return product.vendor || '';
    if (key === 'productType') return product.productType || '';
    // Other metafields would need to be added to the GQL query
    return '';
  }
  */
  /*
function getProductMeta(product, key) {
  if (key === 'vendor') return product.vendor || '';
  if (key === 'productType') return product.productType || '';

  if (!product.metafields) return '';

  const meta = product.metafields.find(m => m && m.key === key);
  return meta?.value || '';
}
*/
function getProductMeta(product, key) {
  if (key === 'vendor') return product.vendor || '';
  if (key === 'productType') return product.productType || '';

  // ✅ HANDLE VARIANT OPTIONS (Size, Color etc.)
  if (product.options) {
    const option = product.options.find(
      o => o.name.toLowerCase() === key.toLowerCase()
    );

    if (option) return option.values; // return array
  }

  // ✅ HANDLE METAFIELDS
  if (product.metafields) {
    const meta = product.metafields.find(m => m && m.key === key);
    if (meta) return meta.value;
  }

  return '';
}

  function onFilterChange() {
    activeFilters = {};
    document.querySelectorAll('input[type="checkbox"][data-filter-key]:checked').forEach(cb => {
      const k = cb.dataset.filterKey;
      if (!activeFilters[k]) activeFilters[k] = new Set();
      activeFilters[k].add(cb.dataset.filterValue);
    });

    filteredProducts = allProducts.filter(p => {
      return Object.entries(activeFilters).every(([key, vals]) => {
        const pVal = getProductMeta(p, key);
        const pVals = Array.isArray(pVal) ? pVal : [pVal];
        return pVals.some(v => vals.has(v));
      });
    });

    currentPage = 1;
    updateFilterCounts();
    sortAndRender();
  }

  function clearFilters() {
    activeFilters = {};
    filteredProducts = [...allProducts];
    document.querySelectorAll('input[type="checkbox"][data-filter-key]').forEach(cb => {
      cb.checked = false;
    });
    currentPage = 1;
    updateFilterCounts();
    sortAndRender();
  }

  function updateFilterCounts() {
    document.querySelectorAll('.cl-filter-option').forEach(opt => {
      const cb    = opt.querySelector('input');
      const key   = cb.dataset.filterKey;
      const val   = cb.dataset.filterValue;
      const count = allProducts.filter(p => {
        const v = getProductMeta(p, key);
        return Array.isArray(v) ? v.includes(val) : v === val;
      }).length;
      const countEl = opt.querySelector('.cl-filter-option__count');
      if (countEl) countEl.textContent = count > 0 ? `(${count})` : '';
    });
  }

  /* ─────────────────────────────────────────────────────────────
     RENDER
  ───────────────────────────────────────────────────────────── */
  function sortAndRender() {
    filteredProducts = sortProducts(filteredProducts, sortKey);
    currentPage = 1;
    render();
  }

  function render(append = false) {
  const total = filteredProducts.length;
  const start = (currentPage - 1) * perPage;
  const end   = Math.min(start + perPage, total);
  const page  = filteredProducts.slice(start, end);

  // Count
  if (countEl) {
    countEl.textContent = total + (total === 1 ? ' Product' : ' Products');
  }

  // ❗ Only clear if NOT appending
  if (!append) {
    grid.innerHTML = '';
  }

  if (!page.length && !append) {
    showEmpty();
  } else {
    const frag = document.createDocumentFragment();
    page.forEach(p => frag.appendChild(buildCard(p)));
    grid.appendChild(frag);
  }

  buildPagination(total);
}

 function buildCard(product) {
  const li = document.createElement('li');
  li.className = 'js-pagination-result';

  const img = product.featuredImage;
  const secondImg = product.images?.edges?.[1]?.node;

  const variants = product.variants?.edges || [];

  const firstVariant = variants[0]?.node;

  const priceVal = parseFloat(product.priceRange?.minVariantPrice?.amount || 0);
  const compare = parseFloat(product.compareAtPriceRange?.minVariantPrice?.amount || 0);
  const currency = product.priceRange?.minVariantPrice?.currencyCode || 'GBP';

  const fmt = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency
  });

  /* ───── VAT LOGIC (YOUR SAME LOGIC) ───── */
  let exVatPrice = priceVal;
  let incVatPrice = priceVal;

  if (
    product.id.includes('2417327276089') ||
    product.id.includes('2417198759993')
  ) {
    exVatPrice = priceVal;
  } else {
    exVatPrice = priceVal / 1.2;
  }

  /* ───── INVENTORY LOGIC ───── */
  let totalQty = 0;
  let inventoryPolicy = '';

  variants.forEach(v => {
    if (v.node.quantityAvailable > 0) {
      totalQty += v.node.quantityAvailable;
    }
    if (v.node.inventoryPolicy === 'CONTINUE') {
      inventoryPolicy = 'continue';
    }
  });

  let inventoryText = '';

  if (totalQty <= 0) {
    if (inventoryPolicy === 'continue') {
      inventoryText = 'Backordered';
    } else if (product.availableForSale) {
      inventoryText = 'In stock';
    }
  } else if (totalQty <= 5) {
    inventoryText = `Low stock (${totalQty})`;
  } else {
    inventoryText = 'In stock';
  }

  /* ───── BUTTON LOGIC ───── */
  let buttonHtml = '';

if (variants.length === 1 && firstVariant?.availableForSale) {
  buttonHtml = `
    <button class="btn btn--primary w-full js-add-to-cart"
      data-variant-id="${firstVariant.id}">
      
      <span class="quick-add-btn-icon">
        <span class="visually-hidden">Add to cart</span>
      </span>

      <span class="quick-add-btn-text">
        Add to cart
      </span>
    </button>

    <a href="/products/${product.handle}" 
       class="btn btn--secondary quick-add-view-btn">
      View Details
    </a>
  `;
} else {
  buttonHtml = `
    <a href="/products/${product.handle}" 
       class="btn btn--primary w-full">
      Choose options
    </a>

    <a href="/products/${product.handle}" 
       class="btn btn--secondary quick-add-view-btn">
      View Details
    </a>
  `;
}

  const compareHtml = compare > priceVal
    ? `<span class="price--compare">${fmt.format(compare)}</span>`
    : '';

  li.innerHTML = `
    <product-card class="card card--product h-full relative flex">

      <div class="card__media ${secondImg ? 'has-hover-image' : ''} relative">
        <a href="/products/${product.handle}" class="media block relative" style="padding-top:100%;">
          
          ${img ? `<img src="${img.url}" class="img-fit card__main-image">` : ''}

          ${secondImg ? `<img src="${secondImg.url}" class="img-fit card__hover-image">` : ''}

        </a>
      </div>

      <div class="card__info-container flex flex-col flex-auto relative">
        <div class="card__info w-full">

          <p class="card__vendor text-sm text-theme-light">
            ${product.vendor || ''}
          </p>

          <p class="card__title font-bold">
            <a href="/products/${product.handle}" class="card-link">
              ${product.title}
            </a>
          </p>

          <div class="price">
            <span>${fmt.format(exVatPrice)}</span> <span>Ex. VAT</span>
            <p><span>${fmt.format(incVatPrice)}</span> <span>Inc. VAT</span></p>
            ${compareHtml}
          </div>

          ${inventoryText ? `
            <div class="product-inventory__status text-xs mt-2">
              ${inventoryText}
            </div>
          ` : ''}

        </div>

        <div class="card__quick-add
          mob:card__quick-add--below
          
          desktop:card__quick-add--below
          
         mt-auto flex flex-col gap-2">
          ${buttonHtml}
        </div>

      </div>

    </product-card>
  `;

  return li;
}
  /* ─────────────────────────────────────────────────────────────
     PAGINATION
  ───────────────────────────────────────────────────────────── */
  function buildPagination(total) {
  if (!paginationEl) return;

  paginationEl.innerHTML = '';

  const totalPages = Math.ceil(total / perPage);

  // If only 1 page → no pagination
  if (totalPages <= 1) return;

  const visibleResults = Math.min(currentPage * perPage, total);

  const percent = ((visibleResults / total) * 100).toFixed(1);

  const hasMore = currentPage < totalPages;

  const wrapper = document.createElement('div');
  wrapper.className = 'pagination--modern text-center w-full';

  wrapper.innerHTML = `
    <span class="pagination__text">
      Showing ${visibleResults} of ${total} products
    </span>

    <div class="pagination__bar-wrapper mt-4">
      <div class="pagination__bar" style="width:${percent}%"></div>
    </div>

    ${
      hasMore
        ? `<button class="btn btn--secondary mt-6 js-load-more">
            Show more
          </button>`
        : ''
    }
  `;

  paginationEl.appendChild(wrapper);

  // LOAD MORE CLICK
  const btn = wrapper.querySelector('.js-load-more');
  if (btn) {
    btn.addEventListener('click', () => {
      currentPage++;
      render(true); // 👈 append mode
    });
  }
}

  function pageBtn(label, disabled) {
    const btn = document.createElement('button');
    btn.className = 'btn btn--secondary pagination__item';
    btn.textContent = label;
    btn.disabled   = disabled;
    return btn;
  }

  function getPageRange(current, total) {
    if (total <= 7) return Array.from({length: total}, (_, i) => i + 1);
    const pages = [1];
    if (current > 3) pages.push('…');
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) pages.push(i);
    if (current < total - 2) pages.push('…');
    pages.push(total);
    return pages;
  }

  function scrollToGrid() {
    grid?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ─────────────────────────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────────────────────────── */
  function showLoading(state) {
    if (!loadingEl) return;
    loadingEl.style.display = state ? 'flex' : 'none';
  }

  function showEmpty() {
    if (!grid) return;
    grid.querySelectorAll('.cl-empty').forEach(el => el.remove());
    const p = document.createElement('p');
    p.className   = 'cl-empty';
    p.textContent = 'No products found.';
    grid.appendChild(p);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escAttr(str) { return escHtml(str); }

})();
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.js-add-to-cart');
  if (!btn) return;

  const variantId = btn.dataset.variantId;

  btn.disabled = true;
  const originalText = btn.innerText;
  btn.innerText = 'Adding...';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    btn.innerText = 'Added ✓';
  } catch (err) {
    btn.innerText = 'Error';
  }

  setTimeout(() => {
    btn.innerText = originalText;
    btn.disabled = false;
  }, 1500);
});

document.addEventListener('click', function(e) {
  const btn = e.target.closest('#cl-view-all-btn');
  if (!btn) return;

  document.querySelectorAll('.is-hidden-sub').forEach(el => {
    el.classList.remove('is-hidden-sub');
  });

  btn.remove(); // remove button after click
});